/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON, FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON, } from './FxIdApplicationDataConnectionsDriversDriverOutputDto';
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Data': FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Data': FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfDriverOutputDto.js.map